import nalandaLogo from '../Components/Assets/images/nalanda_logo.png';

/** Global company logo asset for jsPDF documents. */
export const COMPANY_LOGO_SRC = nalandaLogo;

/** Default top-left placement for PDF headers. */
export const COMPANY_LOGO_DEFAULTS = {
  x: 10,
  y: 6,
  width: 32,
  height: 9,
};

/**
 * Adds the global company logo to the top-left of a jsPDF document.
 * @param {import('jspdf').jsPDF} doc
 * @param {{ x?: number, y?: number, width?: number, height?: number }} [options]
 */
export const addCompanyLogoToPdf = (doc, options = {}) => {
  const placement = { ...COMPANY_LOGO_DEFAULTS, ...options };
  doc.addImage(
    nalandaLogo,
    'PNG',
    placement.x,
    placement.y,
    placement.width,
    placement.height
  );
  return placement;
};

export default nalandaLogo;
